import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactFormComponent from '../components/ContactForm';

const Contact = () => {
    return (
        <>
            <Helmet>
                <title>Contact Us - Community Plus Care Services</title>
                <meta name="description" content="Get in touch with Community Plus Care Services for inquiries, support, or feedback." />
            </Helmet>
            <ContactFormComponent />
        </>
    );
};

export default Contact;
